export enum MobileWalletDialogRoutes {
  Default = '/',
  Start = '/start',
  Saved = '/saved',
  Rename = '/rename',
  Delete = '/delete',
  Backup = '/backup',
  ConfirmDelete = '/delete/confirm',
  Create = '/create',
  KeepSafe = '/create/keep-safe',
  CreateBackup = '/create/backup',
  CreateBackupConfirm = '/create/backup/confirm',
  CreateBackupSuccess = '/create/backup/success',
  Import = '/import',
  ImportSuccess = '/import/success',
  ImportKeystore = '/import/keystore',
  ImportSeedPhrase = '/import/seed-phrase',
  CreateWordsError = '/create/words-error',
  CreateSkipConfirm = '/create/skip-confirm',
}
